import { hasServiceWorker, clearCache } from './cache';

const serviceWorker = (hasServiceWorker && navigator.serviceWorker) as typeof navigator.serviceWorker;

export function clearCacheAndUnregisterServiceWorker() {
  if (!hasServiceWorker) {
    return Promise.resolve([]);
  }
  return clearCache().then(() => {
    return serviceWorker
      .getRegistrations()
      .then(registrations => Promise.all(registrations.map((r: any) => r.unregister())));
  });
}

let registrationPromise: Promise<any> | null = null;
export function registerServiceWorker() {
  if (!hasServiceWorker) {
    return Promise.resolve(null);
  }
  if (!registrationPromise) {
    // Just to make it simpler in dev to reload the service worker
    (window as any).killServiceWorker = () => {
      clearCacheAndUnregisterServiceWorker().then(
        () => {
          console.log('Service worker unregistered and cached cleared');
        },
        () => {
          console.warn('Service worker could not be unregistered');
        },
      );
    };

    registrationPromise = serviceWorker
      .register(window.SERVICE_WORKER_URL, { scope: '/' })
      .then((registration: any) => {
        if (serviceWorker.controller) {
          return serviceWorker;
        }
        return new Promise((resolve, reject) => {
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'activated' && serviceWorker.controller) {
                resolve(serviceWorker);
              }
            });
          });
        });
      });
  }
  return registrationPromise;
}
